import React from 'react';

interface ProgressBarProps {
  value: number;
  max?: number;
  color?: 'primary' | 'success' | 'warning' | 'danger' | 'secondary';
  size?: 'sm' | 'md';
  showLabel?: boolean;
  label?: string;
}

const colorMap = {
  primary: 'bg-primary',
  success: 'bg-success',
  warning: 'bg-warning',
  danger: 'bg-danger',
  secondary: 'bg-secondary',
};

export default function ProgressBar({ value, max = 100, color = 'success', size = 'sm', showLabel = false, label }: ProgressBarProps) {
  const pct = Math.min(100, Math.round((value / max) * 100));
  const h = size === 'md' ? 'h-2.5' : 'h-1.5';
  return (
    <div className="w-full">
      {(showLabel || label) && (
        <div className="flex items-center justify-between mb-1">
          {label && <span className="text-xs text-muted-foreground">{label}</span>}
          {showLabel && <span className="text-xs font-medium text-foreground font-tabular">{pct}%</span>}
        </div>
      )}
      <div className={`w-full bg-muted rounded-full overflow-hidden ${h}`}>
        <div
          className={`${h} rounded-full transition-all duration-700 ${colorMap[color]}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}